<template>
  <b-container class="grade-modal-form">

    <b-table-simple bordered>
      <b-tr class="single-table">
        <b-td class="header">
          <b>{{ experimentColorItem.title }}</b>
        </b-td>
        <b-td>
          <strong :class="'text-' + getEvaluationColor(experimentColorItem.color)">
            {{ experimentColorItem.color.toUpperCase() }}
          </strong>
        </b-td>
      </b-tr>
    </b-table-simple>

    <b-table :fields="evaluationsFields"
             :items="evaluationsItems"
             bordered
             class="table-responsive"
             responsive
             striped
             thead-class="d-none">
      <template v-slot:cell(title)="row">
        <strong class="header">{{ row.value }}</strong>
      </template>
      <template v-slot:cell(evaluation)="row">
        <strong :class="'text-' + getEvaluationColor(row.value)">
          {{ row.value.toUpperCase() }}
        </strong>
      </template>
    </b-table>

    <b-table v-if="!isRapidAccessTechnicalModal"
             :fields="commentsForUserFields"
             :items="commentsForUserItems"
             bordered
             class="table-responsive"
             responsive
             striped
             thead-class="d-none">
      <template v-slot:cell(title)="row">
        <strong class="header">{{ row.value }}</strong>
      </template>
    </b-table>
  </b-container>
</template>

<script>
  import trafficLightsOptions from '@/json/trafficLightsAcceptanceMark';
  import trafficLightsOptionsSafety from '@/json/trafficLightsAcceptanceMarkSafety';
  import {
    getCommonEvaluationsItems,
    getCommentsForUserItems,
    getFinalGradeItem,
    getManagementEvaluationItem,
    getExperimentColorItem,
  } from '@/helpers/evaluationsSummaryTable';
  import { isScientificMerit } from '@/helpers/evaluation/rapid-access/rapidAccessEvaluations';

  export default {
    name: 'EvaluationsSummaryTable',
    props: {
      value: {
        type: Object,
        default: () => {
        },
      },
      isRapidAccessTechnicalModal: {
        type: Boolean,
        default: false,
      },
    },
    data() {
      return {
        evaluationsFields: [
          { key: 'title' },
          { key: 'comment' },
          { key: 'evaluation' },
        ],
        proposal: JSON.parse(JSON.stringify(this.value)),
        trafficLightsOptions,
        trafficLightsOptionsSafety,
      };
    },
    computed: {
      evaluationsItems() {
        let allItems = getCommonEvaluationsItems(this.proposal);
        if (this.isRapidAccessTechnicalModal) {
          allItems = this.getItemsForRapidAccessTechnicalModal(allItems);
        }
        return allItems;
      },
      commentsForUserFields() {
        return this.evaluationsFields.slice(0, -1);
      },
      commentsForUserItems() {
        return getCommentsForUserItems(this.proposal);
      },
      experimentColorItem() {
        return getExperimentColorItem(this.proposal);
      },
    },
    methods: {
      getEvaluationColor(evaluation) {
        let variant = 'secondary';
        const options = [...this.trafficLightsOptions, ...this.trafficLightsOptionsSafety];
        options.forEach((option) => {
          if (option.value === evaluation) {
            variant = option.disabledVariant;
          }
        });
        return variant;
      },
      getItemsForRapidAccessTechnicalModal(allItems) {
        const rapidAccessItems = allItems.slice(0, -1);
        if (isScientificMerit(this.proposal)) {
          rapidAccessItems.push(getFinalGradeItem(this.proposal));
        }
        rapidAccessItems.push(getManagementEvaluationItem(this.proposal));
        return rapidAccessItems;
      },
    },
  };
</script>

<style lang="scss" scoped>
  .grade-modal-form {
    padding: 0 !important;
    margin: 0 0 1rem 0 !important;
    max-width: none;
  }

  .single-table {
    background-color: #e9ecef;
  }
</style>
